import * as React from 'react';
import { useParams } from 'react-router-dom';
import { get } from 'lodash';
import intl from 'react-intl-universal';

import Loading from '@src/components/pc/Loading';
import LanguageChange from '../../components/LanguageChange';
import { CompanyType } from '../../services/getQuestionnaireTpl';

import useTemplate from '../../model/getTemplate';

import './index.less';

const { useEffect, useRef, useState, useLayoutEffect } = React;
const Container: React.FC = ({ children }) => {
  const { loading, data, getTemplate } = useTemplate();
  const titleContainerRef = useRef<HTMLDivElement>();
  const [companyNameStyle, setCompanyNameStyle] = useState({});
  const [titleInfoStyle, setTitleInfoStyle] = useState({});
  const { questionnaire_token } = useParams<{ questionnaire_token: string }>();
  const isBytedance = get(data, 'questionnaire_tenant') === CompanyType.Bytedance;
  const titleInfo =
    get(data, 'questionnaire_template_info.title_info.i18n_name') || intl.get('title');
  const companyName = get(data, 'company_name.i18n_name', '');

  // 由于文字只展示在左侧纯蓝色背景图上，当主标题、副标题过长时，需要对其进行等比缩放
  // 缩小比例 = 左侧纯蓝色背景图实际宽度 / 标题实际长度
  // 现在支持最多两行文本，计算逻辑相应调整
  useLayoutEffect(() => {
    const titleContainerWidth = titleContainerRef.current?.clientWidth;
    if (titleContainerWidth) {
      if (titleInfo) {
        let textWidth = 0;
        const regex = /[a-zA-Z0-9]/;
        for (let i = 0; i < titleInfo.length; i++) {
          if (regex.test(titleInfo[i])) {
            textWidth += 22; // 英文字符的width取font-size的一半
          } else {
            textWidth += 45;
          }
        }
        // 计算主标题在移动端展示的实际宽度（单位：px）
        // 考虑到最多两行文本，调整计算逻辑
        const avgCharWidth = textWidth / titleInfo.length;
        const charsPerLine = Math.floor(titleContainerWidth / (avgCharWidth * (2 / 75) * 16));
        const maxCharsTwoLines = charsPerLine * 2;

        let scale = 1;
        // 当标题字符数超过两行能显示的最大字符数时，进行缩放
        if (titleInfo.length > maxCharsTwoLines) {
          scale = Math.sqrt(maxCharsTwoLines / titleInfo.length);
        }
        const left = (titleContainerWidth * (1 - scale)) / 2;
        setTitleInfoStyle({ scale: `${scale}`, left: `-${left}px`, width: '100%' });
      }
      if (companyName) {
        let textWidth = 0;
        const regex = /[a-zA-Z0-9]/;
        for (let i = 0; i < companyName.length; i++) {
          if (regex.test(companyName[i])) {
            textWidth += 12;
          } else {
            textWidth += 28;
          }
        }
        // 计算副标题在移动端展示的实际宽度（单位：px）
        const computedTextWidth = textWidth * (2 / 75) * 20;
        let scale = 1;
        if (computedTextWidth > titleContainerWidth) {
          scale = titleContainerWidth / computedTextWidth;
        }
        const left = (titleContainerWidth * (1 - scale)) / 2;
        setCompanyNameStyle({ scale: `${scale}`, left: `-${left}px`, width: '100%' });
      }
    }
  }, [data]);

  useEffect(() => {
    getTemplate(questionnaire_token);
  }, []);
  return (
    <div className="mobile__detail-wrapper">
      {loading ? (
        <Loading />
      ) : (
        <>
          <header
            className="mobile__detail__header"
            style={{
              backgroundImage: `url('${process.env.PUBLIC_URL}/mobile_questionnaire_bg.png')`
            }}
          >
            {isBytedance && <LanguageChange />}
            <div className="mobile__detail__content__header__container" ref={titleContainerRef}>
              <div className="mobile__detail__content__header__title">
                <div className="mobile__detail__content__header__titleInfo" style={titleInfoStyle}>
                  {titleInfo}
                </div>
                <div
                  className="mobile__detail__content__header__companyname"
                  style={companyNameStyle}
                >
                  {companyName}
                </div>
              </div>
            </div>
          </header>
          {children}
        </>
      )}
    </div>
  );
};

export default Container;
